import { NosIdWithText } from '@nosinovacao/fe-icons';
import { SheetContentPrimitive, SheetPrimitive, useI18n } from '@nosinovacao/nosid-mfe-common';
import { useNavbarContext } from '../../context/navbar';
import { MainNavSheetContent } from './main-section';
import { TvNavSheetContent } from './tv-section';

export function DesktopNavbar() {
  const { t } = useI18n();

  const {
    activeSection: sectionName,
    setActiveSection: setSectionName,
    setSheetOpen,
  } = useNavbarContext();

  return (
    <aside className="sticky top-0 z-[51] flex h-dvh  w-full flex-col  justify-center gap-[88px] overflow-y-auto bg-nos-neutral-0 p-10 pr-0">
      <div className="flex justify-center pr-10">
        <NosIdWithText className="text-nos-neutral-900" width={124} height={48} />
      </div>
      <MainNavSheetContent
        currentSection={sectionName}
        onClose={() => {}}
        goToSection={setSectionName}
      />
      <SheetPrimitive
        open={sectionName === 'tv'}
        onOpenChange={(o) => {
          if (!o) setSectionName('main');
          setSheetOpen(false);
        }}
      >
        <SheetContentPrimitive
          skin="light"
          aria-label={t('Common.Navbar.ContentLabel')}
          animationDirection="left"
          overlayClassName="left-[338px]"
          className="fixed inset-y-0 left-[338px] right-0 z-50 w-dvw tablet:w-[min(50dvw,384px)] [&>*]:flex [&>*]:flex-col"
        >
          <TvNavSheetContent
            backButton={false}
            goToMainSection={() => setSectionName('main')}
            onClose={() => setSectionName('main')}
            className="-mb-8 gap-6 py-8"
          />
        </SheetContentPrimitive>
      </SheetPrimitive>
    </aside>
  );
}
